<template>
  <div>
    <div class="m-background m-background--feedback"
     :style="{ backgroundImage: `url('${getImageDomain}${backgroundImage}')` }"></div>
    <Header />
    <div class="l-container l-container--with-questions">
      <div class="m-feedback__question">
        <span v-html="getQuestion"></span>
      </div>
      <div class="columns">
        <div class="column">
          <!-- If the question has been answered -->
          <div v-if="checkIfAnswered()" class="m-feedback">
            <div class="m-feedback__inner">
              <div class="m-feedback__header">
                <div class="m-feedback__details">
                  <p class="m-feedback__detail clearfix">
                    <span>From:</span> {{ levelFeedback.from}}
                  </p>
                  <p class="m-feedback__detail clearfix">
                    <span>To:</span> {{ toEmail }}</p>
                  <p class="m-feedback__detail clearfix">
                    <span>Subject:</span> {{ subjectLine }}</p>
                </div>
                <img class="m-feedback__avatar" :src="getImageDomain + getAvatar"/>
              </div>
            </div>
            <div class="m-feedback__body">
              <p>{{ levelFeedback.welcome }}</p>
              <p>{{ uniqueFeedback }}</p>
              <p>{{ levelFeedback.signoff }}</p>
              <p>{{ levelFeedback.name }}</p>
            </div>
          </div>
          <!-- If the question has not been answered -->
          <div v-else class="columns is-centered">
            <div class="column is-6">
              <div class="m-feedback__no-answer">
                <h3 class="u-text--center">You haven't answered this question</h3>
                <div>
                  <a class="m-btn m-btn__secondary
                  m-btn__secondary--with-text
                  m-btn__secondary--not-fixed"
                  @click="showQuestion()">Continue
                    <img class="m-btn__arrow" src="~@/assets/images/white-arrow.png" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <router-link v-if="checkIfFinalQuestion()"
          class="m-btn m-btn__secondary m-btn__secondary--feedback final question m-btn--right"
          :to="{ name: 'completedLevels' }"></router-link>
          <a v-else-if="checkIfLastQuestionInLevel()"
          class="m-btn lastquestion m-btn__secondary m-btn__secondary--feedback m-btn--right"
          @click="completeLevel()"></a>
          <a v-else class="m-btn m-btn__secondary normalquestion
           m-btn__secondary--feedback m-btn--right"
          @click="nextQuestion()"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Header from '../header/Header';

export default {
  components: {
    Header,
  },
  computed: {
    ...mapGetters(['getLevel', 'getCurrentLevelDetail', 'getScore', 'getQuestionIndex', 'getQuestionTracker', 'getImageDomain']),
    levelFeedback() {
      const level = this.getCurrentLevelDetail(this.getLevel);
      return level.feedback;
    },
    uniqueFeedback() {
      const questionNumber = this.$route.params.id - 1;
      const question = this.$store.state.questions[questionNumber];
      const answer = question.answer;
      const feedback = question.responses.find(response => response.id === answer);
      return feedback.feedback;
    },
    toEmail() {
      const questionNumber = this.$route.params.id - 1;
      const question = this.$store.state.questions[questionNumber];
      return question.feedbackTo;
    },
    subjectLine() {
      const questionNumber = this.$route.params.id - 1;
      const question = this.$store.state.questions[questionNumber];
      return question.feedbackSubject;
    },
    backgroundImage() {
      const questionNumber = this.$route.params.id - 1;
      const question = this.$store.state.questions[questionNumber];
      return question.feedback_background;
    },
    getAvatar() {
      const level = this.getCurrentLevelDetail(this.getLevel);
      return level.feedback.avatar;
    },
    getQuestion() {
      const questionNumber = this.$route.params.id - 1;
      const question = this.$store.state.questions[questionNumber];
      return question.text;
    },
  },
  methods: {
    ...mapGetters(['getCurrentQuestion', 'getCurrentQuestions']),
    ...mapActions(['setLevel']),
    setUserLevel() {
      const questionNumber = this.$route.params.id;
      const question = this.$store.state.questions[questionNumber];
      const level = question.level;
      this.setLevel(level);
    },
    nextQuestion() {
      const nextQuestion = this.getQuestionTracker + 1;
      this.setUserLevel();
      this.checkIfLastQuestionInLevel();
      this.$router.push({ name: 'question', params: { id: nextQuestion } });
    },
    showQuestion() {
      this.$router.push({ name: 'question', params: { id: this.$route.params.id } });
    },
    checkIfAnswered() {
      let answered = true;
      const questionNumber = this.$route.params.id - 1;
      const question = this.$store.state.questions[questionNumber];
      if (question.answer === 0) {
        answered = false;
      }
      return answered;
    },
    checkIfLastQuestionInLevel() {
      let lastQuestion = false;
      const level = this.$store.getters.getLevel;
      const questionsInCurrentLevel =
       this.$store.state.questions.filter(question => question.level === level);
      const numberOfQuestionsInCurrentLevel = questionsInCurrentLevel.length;
      if (this.getQuestionIndex === numberOfQuestionsInCurrentLevel) {
        lastQuestion = true;
      }
      return lastQuestion;
    },
    checkIfFinalQuestion() {
      let finalQuestion = false;
      const countAllQuestions = this.$store.state.questions.length;
      if (this.$store.state.user.question === countAllQuestions) {
        finalQuestion = true;
      }
      return finalQuestion;
    },
    completeLevel() {
      this.setUserLevel();
      this.$router.push({ name: 'chooseLevel' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/questions/Feedback.vue